/* unplugin-vue-components disabled */import { render } from "./ai-input.vue?vue&type=template&id=3c51e448"
import script from "./ai-input.vue?vue&type=script&lang=js"
export * from "./ai-input.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-chat-v2/ai-assistant/ai-input/ai-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c51e448"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c51e448', __exports__)) {
    api.reload('3c51e448', __exports__)
  }
  
  module.hot.accept("./ai-input.vue?vue&type=template&id=3c51e448", () => {
    api.rerender('3c51e448', render)
  })

}


export default __exports__